module.exports = __webpack_public_path__ + "static/media/orange-drop.0a245fef.svg";